import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotVal = (formData.get('website_alt') as string || '').trim();
    if (honeypotVal) {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) return;

    setStatus('loading');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email.trim());
      const res = await fetch('https://readdy.ai/api/form/d96c3ncut53jbls7km90', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const code = (parsed as { code?: string }).code;
      if (res.ok && code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = (parsed as { meta?: { message?: string } }).meta?.message || (parsed as { message?: string }).message || '';
        if (serverMsg.toLowerCase().includes('spam')) {
          setStatus('success');
          setEmail('');
          return;
        }
        setStatus('error');
        setErrorMsg(serverMsg || '订阅失败，请稍后重试');
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络异常，请稍后重试');
    }
  };

  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="text-center max-w-xl mx-auto mb-10">
        <h2 className="text-3xl md:text-4xl font-black font-heading text-foreground-950 mb-3">
          订阅吃瓜快报
        </h2>
        <p className="text-foreground-500 text-sm mb-8">
          不错过任何91今日吃瓜、今日吃瓜合集更新，第一时间获取最新爆料推送
        </p>

        {status === 'success' ? (
          <div className="py-4 px-6 rounded-2xl bg-accent-100 text-accent-700 text-sm font-medium">
            <i className="ri-check-line mr-1.5"></i>
            订阅成功！感谢您的关注，最新吃瓜资讯将第一时间送达。
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form=""
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <div className="honeypot-wrapper">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="flex-1 px-5 py-3 rounded-full bg-background-100 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="px-6 py-3 rounded-full bg-accent-500 text-white font-semibold text-sm hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer disabled:opacity-60"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-1.5">
                  <i className="ri-loader-4-line animate-spin"></i> 提交中...
                </span>
              ) : (
                <span className="flex items-center gap-1.5">
                  立即订阅 <i className="ri-arrow-right-line"></i>
                </span>
              )}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="text-red-500 text-xs mt-3">{errorMsg || '订阅失败，请稍后重试。'}</p>
        )}
      </div>

      {/* Hot Topics Banner */}
      <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 max-w-4xl mx-auto">
        <span className="text-xs text-foreground-400 whitespace-nowrap">今日热搜：</span>
        <span className="px-4 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600 whitespace-nowrap">#顶流深夜密会 5.2亿阅读</span>
        <span className="px-4 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600 whitespace-nowrap">#男星劈腿实锤 6.7亿阅读</span>
        <span className="px-4 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600 whitespace-nowrap">#导演性骚扰举报 5.8亿阅读</span>
        <span className="px-4 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600 whitespace-nowrap">#网红偷税被封 4.8亿阅读</span>
        <span className="px-4 py-1.5 rounded-full bg-background-100 text-xs text-foreground-600 whitespace-nowrap">#企业家出轨门 4.5亿阅读</span>
      </div>
    </section>
  );
}